__turbopack_context__.v({
  "grid": "QuickActions-module-scss-module__no2oiq__grid",
  "section": "QuickActions-module-scss-module__no2oiq__section",
  "subtitle": "QuickActions-module-scss-module__no2oiq__subtitle",
  "title": "QuickActions-module-scss-module__no2oiq__title",
});
